/**
 * navigator.clipboard.writeText 是 HTML5 新增的一个 API，用于将文本内容异步写入剪贴板。关于其兼容性，以下是详细的分析：

 一、支持的主流浏览器及其版本
  Chrome‌：从较早的版本开始支持 navigator.clipboard.writeText。
  Firefox‌：在较新版本中支持，但需要注意隐私设置和版本兼容性。例如，在某些隐私模式下或旧版 Firefox 中，可能会禁用此功能。
  Safari‌：同样支持 navigator.clipboard.writeText，但可能需要在特定的设置下启用。
  Edge‌：作为 Chromium 内核的浏览器，也支持该 API。
 二、已知的兼容性问题或限制
 ‌旧版浏览器不支持‌：一些较旧的浏览器版本（如 Internet Explorer）不支持 navigator.clipboard API，需要使用其他方法（如 window.clipboardData.setData 或 document.execCommand('copy')）来实现剪贴板操作。
 ‌权限问题‌：在某些情况下（如安卓的 WebView），可能会遇到权限问题，导致无法使用 navigator.clipboard.writeText。此时，需要用户明确授权，或者采用其他方法来实现复制功能。
 ‌隐私模式和第三方库限制‌：在浏览器的隐私模式下，或者在某些使用第三方库的环境中，可能会限制对剪贴板的访问。
 三、解决兼容性问题的方法或建议
 ‌使用 Polyfill‌：为了兼容旧版或特定环境下的浏览器，可以引入第三方库（如 clipboard.js）来模拟 navigator.clipboard API 的行为。
 ‌条件判断‌：在代码中添加条件判断，根据浏览器的支持情况选择不同的实现方法
 * @param text
 * @returns {Promise<void>}
 */
export async function copyTextToClipboard(text) {
  if (navigator.clipboard && navigator.permissions) {
    try {
      await navigator.clipboard.writeText(text)
      // console.log('复制成功!')
    } catch (err) {
      console.error('无法复制: ', err)
    }
  } else {
    // 降级方案：使用 document.execCommand('copy')
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.width = '0'
    textArea.style.position = 'fixed'
    textArea.style.left = '-999px'
    textArea.style.top = '-999px'
    textArea.setAttribute('readonly', 'readonly')
    document.body.appendChild(textArea)
    textArea.select()
    const success = document.execCommand('copy')
    document.body.removeChild(textArea)
    if (!success) {
      throw new Error('无法复制文本')
    }
  }
}
